namespace Portico.Decorators {

    export function Service(module: string, service: string) {
        return function decorator(target: any) {
            if (!module || !service) {
                throw new Error('@Service(module, service) must have module and service names!');
            }

            angular.module(module).service(service, target);
        };
    }
}